import { create } from 'zustand';

export interface Toast {
  readonly id: number;
  readonly kind: 'info' | 'success' | 'error';
  readonly text: string;
}

interface ToastState {
  toasts: Toast[];
  show: (kind: Toast['kind'], text: string) => void;
}

let seq = 0;

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  show: (kind, text) => {
    const id = ++seq;
    set((s) => ({ toasts: [...s.toasts, { id, kind, text }] }));
    window.setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
    }, kind === 'error' ? 7000 : 3500);
  },
}));

export const toast = {
  info: (t: string) => {
    useToasts.getState().show('info', t);
  },
  success: (t: string) => {
    useToasts.getState().show('success', t);
  },
  error: (t: string) => {
    useToasts.getState().show('error', t);
  },
};
